import React, { useState } from "react";
import "./socialpage.css";

function importAll(r) {
  return r.keys().map(r);
}

const images = importAll(
  require.context("../assets/imagesGallary", false, /\.(png|jpe?g|webp)$/)
);

function SocialMediaFeed() {

  const [activeImage, setActiveImage] = useState(null);

  return (
    <>
      <div className="gallery-grid">

        {images.map((img, index) => (
          <div className="gallery-item" key={index}>
            <img
              src={img}
              alt="gallery"
              onClick={() => setActiveImage(img)}
            />
          </div>
        ))}

      </div>

      {/* Fullscreen viewer */}
      {activeImage && (
        <div
          className="fullscreen-view"
          onClick={() => setActiveImage(null)}
        >
          <img src={activeImage} alt="full" />
        </div>
      )}
    </>
  );
}

export default SocialMediaFeed;